import { Grape, TreePine, Waves, Castle, Gift } from "lucide-react";

export const THEMES = [
  { v: "vendanges", l: "Vendanges", icon: Grape },
  { v: "noel", l: "Marchés de Noël", icon: Gift },
  { v: "plages", l: "Plages", icon: Waves },
  { v: "villages", l: "Villages", icon: Castle },
  { v: "nature", l: "Nature", icon: TreePine },
];

export const themeLabel = (v) => THEMES.find((t) => t.v === v)?.l;

export const ThemePicker = ({ value, onPick, disabled }) => (
  <div data-testid="season-themes" className="mt-3 flex flex-wrap items-center gap-2">
    <span className="text-sm text-gray-300 mr-1">Idées de saison :</span>
    {THEMES.map((t) => {
      const on = value === t.v;
      return (
        <button type="button" key={t.v} disabled={disabled} onClick={() => onPick(t.v)} aria-pressed={on}
          data-testid={`season-theme-${t.v}`}
          className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm border transition-colors disabled:opacity-50 ${on ? "bg-emerald-500 text-[#0B131E] border-emerald-500 font-semibold" : "text-gray-100 bg-white/5 border-white/15 hover:border-emerald-400 hover:text-white"}`}>
          <t.icon className="w-3.5 h-3.5" />{t.l}
        </button>
      );
    })}
  </div>
);
